import { render } from "./VerticalList.vue?vue&type=template&id=94b4e03a"
import script from "./VerticalList.vue?vue&type=script&lang=js"
export * from "./VerticalList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./VerticalList.vue?vue&type=style&index=0&id=94b4e03a&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__